import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'

import { GroupsImagesContext } from '../../domain-repository/GroupsImagesRepository'
import { DomainContext, ALWAYS_PRESENT } from '../../domain-repository/DomainRepository'

import { isSafetyExtra } from '../../utils/utils'

import withLang from '../../withLang'
import DriverInfoHeader from '../../components/PageHeader'
import { FooterWithPrice } from '../../components/Footer'
import TrackingPage from '../../components/TrackingPage'

function isArrayEqual(ar1, ar2) {
  return !ar1.some(item => ar2.indexOf(item) === -1) && ar1.length === ar2.length;
}

function allValuesExist(arr1, arr2) {
  return arr1.every(v1 => arr2.find(v2 => v1 === v2) !== undefined)
}

export const PACKS_CONFIGS = {
  RF1: { colorClass: 'board-green', discounts: { ACDW1: 30 } },
  RF2: { colorClass: 'board-green', discounts: { ACDW1: 30, ASTOP: 30 } },
  IF1: { colorClass: 'board-green', discounts: { ACDW1: 50 } },
  IF2: { colorClass: 'board-orange', highlight: true, showNoDiscountValue: true, discounts: { ACDW1: 50, ASTOP: 50 } },
  IF3: { colorClass: 'board-silver', discounts: { ACDW1: 50, ASTOP: 50, PAI: 50 } },
}

function SafetyPacksPage({ history, match }) {
  const { t } = useTranslation();

  const {
    isCorporate,
    appFlowConfigs,
    flowNextRoute,
    getInsuranceExtras,
    reservationExtras,
    getValidSafetyExtras,
    reservation,
    getExcessForExtras,
    computeExtraPrices,
    insuranceSelectedExtras,
    setInsuranceSelectedExtras,
    changeInsurancePack,
    insuranceSelectedPack,
    setInsuranceSelectedPack,
    mapPriceForPack,
    getBestPackForExtras,
    selectedExtras,
    rentalAgreementQuoteValue,
    canGoInsurancePacksPage,
    flowPreviousRoute,
    saveSessionExtras,
    getQuantityOfExtra,
  } = useContext(DomainContext)

  const [packs, setPacks] = useState([])

  const { groupsConfigurations } = useContext(GroupsImagesContext)

  const [selectedPack, setSelectedPack] = useState(insuranceSelectedPack?.extraId || null)

  useEffect(() => {
    const allPacks = (reservation && reservation.packs ? reservation.packs : [])

    const configuredPacks = (appFlowConfigs.insurancePacks ? appFlowConfigs.insurancePacks.packs : [])
      .filter(p => {
        return reservation.availableExtras.find(_ => _.extraID === p.extraId) !== undefined
      })
      .map(pack => {
        const isHighlight = PACKS_CONFIGS[pack.extraId]?.highlight || false
        return { ...pack, order: isHighlight ? -1 : pack.order + 1 }
      })

    const packIncludedInReservation = reservation.availableExtras.filter(e => e.extraIncluded === 'true').some(e => configuredPacks.find(p => p.extraId === e.extraID) !== undefined)

    const rejectedPackBasic = reservation.isExclusiveReservation && getQuantityOfExtra({ extraID: 'PE' }) === 0
    const skipPageByRejectedPackBasic = rejectedPackBasic && reservation.exclusiveReservationsConfigurations ?
      reservation.exclusiveReservationsConfigurations.safetyPacksPageBlocked : false

    if (!skipPageByRejectedPackBasic && canGoInsurancePacksPage() && appFlowConfigs.insurancePacksActive && configuredPacks.length > 0 && !packIncludedInReservation) {

      function calculatePriceAndExcessForPacks(_packs) {

        function calculatePrice(pack) {
          if (pack.price || pack.price === 0) return pack.price

          if (insuranceSelectedPack && pack.extraId === insuranceSelectedPack.extraId) {
            return {
              pricePerDay: insuranceSelectedPack.price !== null ? insuranceSelectedPack.price : insuranceSelectedPack.totalPrice,
              totalPrice: insuranceSelectedPack.totalPrice
            }
          }

          const value = mapPriceForPack(pack)
          const extra = reservation.availableExtras.find(e => e.extraID === pack.extraId)

          return computeExtraPrices({ ...extra, value })
        }

        return _packs.map(pack => {
          const price = calculatePrice(pack)
          return {
            ...pack,
            price: price.pricePerDay || price.totalPrice,
            totalPrice: price.totalPrice,
            excess:
              getExcessForExtras([
                ...reservationExtras,
                { extraID: pack.isReservationPack ? 'CDW' : pack.extraId }
              ], groupsConfigurations)
          }
        }).filter(p => p.price > 0 || p.isReservationPack)
      }

      const reservationPack = {
        isReservationPack: true,
        name: t('yourReservation'),
        color: '',
        extraId: 'RESERVATION',
        price: 0,
        extrasList: reservationExtras.map(e => e.extraID).filter(isSafetyExtra)
      }

      const _packs = calculatePriceAndExcessForPacks([
        reservationPack,
        ...configuredPacks
          .filter(pack => reservationExtras.find(re => re.extraID === pack.extraId) === undefined)
          .filter(pack => {
            if (insuranceSelectedPack && pack.extraId === insuranceSelectedPack.extraId) return true

            if (pack.exclusionExtrasList && pack.exclusionExtrasList.some(e => reservationExtras.find(re => re.extraID === e) !== undefined)) {
              return false
            }

            const packInReservation = getBestPackForExtras([...reservationExtras, ...selectedExtras].map(e => e.extraID), allPacks, true)
            if (packInReservation) {
              const packExtras = pack.extrasList.filter(e => !ALWAYS_PRESENT.includes(e))
              return !packExtras.every(e => packInReservation.extrasList.find(ec => e === ec))
            }
            return true
          })
          .sort((a, b) => a.order - b.order)
      ])

      if (_packs.filter(p => !p.isReservationPack).length === 0) {
        onNext()
      }
      setPacks(_packs)
    } else {
      onNext()
    }
  }, [])

  function isSelected(pack) {
    return selectedPack === pack.extraId
  }

  function onNext() {
    const mappedExtras = packs.filter(pack => !pack.isReservationPack).map(pack => ({
      extraId: pack.extraId,
      price: pack.totalPrice,
      acquired: isSelected(pack),
      removedInReview: false,
      pageId: PageId,
    }))

    saveSessionExtras(mappedExtras)

    return history.location.state && history.location.state.continueUrl ?
      history.push(history.location.state.continueUrl)
      : history.push(flowNextRoute())
  }

  function onSelectClick(pack) {
    if (pack.isReservationPack) {
      changeInsurancePack(null, insuranceSelectedPack)
      setInsuranceSelectedPack(null)
    } else {
      changeInsurancePack(pack, insuranceSelectedPack)
      setInsuranceSelectedPack(pack)
    }

    setSelectedPack(pack.extraId)
  }

  function handlePackInfoClick(pack) {
    history.push(`/safety-packs/${pack.extraId}`)
  }

  return (
    <div style={{ '--vh': '1vh' }}>
      <DriverInfoHeader
        title={t('safety')}
        active={2}
        progress={'50%'}
        handleLogoClick={() => history.push('/start')}
      />
      <main className='page-layout'>
        <div className="container grow">
          <div className="main table-content" style={{ height: '100%' }}>
            <div className='container-small mx-auto w-100'>
              <h1 className="text-center mt-4">{t('mobileInsuranceTitle')}</h1>
              <div className='board-container mt-4 p-1'>
                {packs.map((pack, i) => {
                  const packSelected = isSelected(pack)
                  const isHighlight = PACKS_CONFIGS[pack.extraId]?.highlight || false
                  const packColorClass = PACKS_CONFIGS[pack.extraId]?.colorClass || ''
                  return (
                    <div className={`board ${i === 0 ? 'mt-2' : 'mt-5'} mb-5 ${isHighlight ? 'board-recomended' : ''}`}>
                      {isHighlight ? <div className="badge" style={{ position: 'relative', zIndex: '-1' }}>{t('recomended')}</div> : null}
                      <div className={`board position-relative ${packColorClass}`}>
                        <div className="block-header d-flex align-items-center justify-content-between p-3">
                          <h2 onClick={() => handlePackInfoClick(pack)} className="text-uppercase m-0">{pack.name} <img src={require('../../assets/images/ico-info-white.svg')} className="pl-2" /></h2>
                          {pack.isReservationPack ? null : <div className="price">€ {pack.price} /{t('day')}</div>}
                        </div>
                        <div className="block-content mt-2 px-3 pb-2">
                          <ul className="details p-0">
                            {pack.extrasList.map(extraId => (
                              <li key={extraId}>
                                {t(`${extraId}InsuranceName`, t(`${extraId}Name`))}
                                {!pack.isReservationPack && PACKS_CONFIGS[pack.extraId] !== undefined && PACKS_CONFIGS[pack.extraId]?.discounts[extraId] ?
                                  <img src={require(`../../assets/images/stamp-${PACKS_CONFIGS[pack.extraId]?.discounts[extraId]}.svg`)} width="30" className="stamp"></img>
                                  : null}
                              </li>
                            ))}
                          </ul>
                          <div className="value">
                            <h2 className="text-uppercase m-0">{t('excess')}: €{pack.excess}</h2>
                          </div>
                          <div onClick={() => onSelectClick(pack)} className={`btn btn-orange-hollow btn-select-plan position-absolute text-uppercase ${packSelected ? 'active' : ''}`}>{packSelected ? t('selected') : t('select')}</div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
        <FooterWithPrice
          totalPrice={rentalAgreementQuoteValue}
          totalPriceLabel={t('total')}
          handleNextClick={onNext}
          nextDisabled={!selectedPack}
          handlePrevClick={() => history.location.state && history.location.state.backUrl ? history.replace(history.location.state.backUrl) : flowPreviousRoute(history)}
        />
      </main>
    </div>
  )
}

const PageId = 79
export default withLang(TrackingPage(SafetyPacksPage, PageId))
